/**
 * Set up routing for all UserProfile views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import userProfile views
import CreateUserProfile from './views/CreateUserProfile.js.jsx';
import UserProfileList from './views/UserProfileList.js.jsx';
import SingleUserProfile from './views/SingleUserProfile.js.jsx';
import UpdateUserProfile from './views/UpdateUserProfile.js.jsx';

class UserProfileRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path="/user-profiles" component={UserProfileList} />
        <YTRoute login={true} exact path="/user-profiles/new" component={CreateUserProfile} />
        <Route exact path="/user-profiles/:userProfileId" component={SingleUserProfile}/>
        <YTRoute login={true} exact path="/user-profiles/:userProfileId/update" component={UpdateUserProfile}/>
      </Switch>
    )
  }
}

export default UserProfileRouter;



// WEBPACK FOOTER //
// modules/userProfile/UserProfileRouter.js.jsx